// src/access.ts
export default function access(initialState: {
	currentUser?: API.CurrentUser;
}) {
	const { currentUser } = initialState || {};
	if (!currentUser) return {};

	return {
		canSuperAdmin: currentUser && currentUser.role === 'SUPER_ADMIN',
		canAdmin:
			currentUser.role && ['ADMIN', 'SUPER_ADMIN'].includes(currentUser.role),
		canOfficer:
			currentUser.role &&
			['ADMIN', 'SUPER_ADMIN', 'OFFICER'].includes(currentUser.role),
		canReporter:
			currentUser.role &&
			['ADMIN', 'SUPER_ADMIN', 'REPORTER'].includes(currentUser.role),
		// 新增录入员
		canReporterBnt:
			currentUser.role &&
			['SUPER_ADMIN', 'REPORTER'].includes(currentUser.role),
	};
}
